import { sortByIsPlayer } from "../../../constants";

function FolderItemQuickLook({encounter}) {

    let popupList = {}
    let creatures = encounter.creatures;
    for(let i = 0; i < creatures.length; i++) {
        let c = creatures[i]
        popupList[c.name] = { name: c.name, count: popupList[c.name]?.count+1 || 1, avatarUrl: c.avatarUrl, type: c.type }
    }



    const encNames = Object.entries(popupList).map(([name, { count, avatarUrl, type }]) => ({ name, count, avatarUrl, type }));
    sortByIsPlayer(encNames)
    return (
        <div className="qlContainer" style={{backgroundImage: `url(${encounter.backgroundGuid})`}}> 
            {encNames.length > 0 ? (
                <div className="qlRow"> 
                    {encNames.map((creature, i) => {
                        return (i < 5 ? 
                            <div key={i}>
                                <div className='qlItemContainer'>
                                    {creature.count > 1 &&
                                        <div className="qlCreatureCountContainer">
                                            <b>x{creature.count}</b>
                                        </div>
                                    }
                                    
                                    <div className="qlImageContainer">
                                        <img className="qlRowImage" src={creature.avatarUrl} alt={"list Icon"} />
                                    </div>
                                    <div className="qlNamePopoverContainer">
                                        <b className="qlNamePopover">{creature.name}</b>
                                    </div>
                                </div>
                            </div>
                            : null
                        )
                    })} 
                    {encNames.length > 5 && 
                        <div className="qlCountContainer">
                            <div className="qlCount"><b>...</b></div>
                            <div className="qlCountPopupContainer"  style={{bottom: '120%'}}>
                                <div className="qlCountPopup">
                                    {encNames.map(c => 
                                        <div>
                                            {c.type === 'player' ?
                                                <span> 
                                                    <b>
                                                        {c.name}<i>- PC</i>
                                                    </b>
                                                </span>
                                                :
                                                <span> 
                                                    {c.name} {c.count > 1 && <b>x{c.count}</b>}
                                                </span>
                                            }
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    }
                </div> 
            ) : (
                <div>
                    <div className="qlImageContainer">
                       <div className="qlRowImage" style={{padding: '0px 10px 0px 10px'}}><b>No Creatures</b></div>
                    </div>
                </div>
            )}
            <div className="qlCountContainer">
                <div className="qlCount">👤<b>x{creatures.length}</b></div>
                <div className="qlCountPopupContainer">
                    <div className="qlCountPopup">
                        <b>Total Creatures</b>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FolderItemQuickLook;